import { IMandatoryItem, IMandatoryItemData } from '@/models';
import { ITariffMandatoryItemService } from './tariff-mandatory-item.types';
import { AxiosInstance } from 'axios';

export class TariffMandatoryItemService implements ITariffMandatoryItemService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/tariffs/mandatory-items/';
  }

  fetchTariffMandatoryItems(): Promise<IMandatoryItem[]> {
    return this.axios
      .get<IMandatoryItem[]>(this.endpoint)
      .then(({ data }) => data);
  }

  fetchTariffMandatoryItem(id: number): Promise<IMandatoryItem> {
    return this.axios
      .get<IMandatoryItem>(`${this.endpoint}${id}/`)
      .then(({ data }) => data);
  }

  createTariffMandatoryItem(data: IMandatoryItemData): Promise<IMandatoryItem> {
    return this.axios
      .post<IMandatoryItem>(this.endpoint, data)
      .then(({ data }) => data);
  }

  updateTariffMandatoryItem(data: IMandatoryItemData): Promise<IMandatoryItem> {
    return this.axios
      .patch<IMandatoryItem>(`${this.endpoint}${data.id}/`, data)
      .then(({ data }) => data);
  }

  deleteTariffMandatoryItem(id: number): Promise<void> {
    return this.axios.delete(`${this.endpoint}${id}/`).then(({ data }) => data);
  }
}
